import * as angular from "angular";
import {$agreementsFactory} from "../$agreements.factory";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";



export class AgreementsRequests {

  constructor(private $agreements: $agreementsFactory, private agreementAPI: BringozApi) {
  }

  createAgreement(agreement) {
    return this.$agreements().$put(agreement);
  }

  updateVersion(agreementId, version) {
    const API = this.agreementAPI.actions.updateVersion;
    return this.$$call(API, {}, version, {
      agreementId: agreementId
    });
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$agreements().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.agreements')
  .service('agreementsRequests', AgreementsRequests);
